var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { FaSpinner, FaUndo } from 'react-icons/fa';
import { getPrompts, updatePrompt, resetPrompt } from '../../api/prompts';
import './PromptsManager.scss';
function errorMessage(err) {
    var _a, _b;
    return ((_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) || (err === null || err === void 0 ? void 0 : err.message) || 'Something went wrong';
}
// Admin view: read and override the AI generation system prompts.
function PromptsManager() {
    const [prompts, setPrompts] = useState(null);
    const [drafts, setDrafts] = useState({});
    const [busyKey, setBusyKey] = useState(null);
    const [error, setError] = useState(null);
    const applyList = (list) => {
        setPrompts(list);
        setDrafts(Object.fromEntries(list.map(p => [p.key, p.value])));
    };
    useEffect(() => {
        getPrompts().then(applyList).catch(err => setError(errorMessage(err)));
    }, []);
    const save = (key) => __awaiter(this, void 0, void 0, function* () {
        var _a;
        setBusyKey(key);
        setError(null);
        try {
            applyList(yield updatePrompt(key, (_a = drafts[key]) !== null && _a !== void 0 ? _a : ''));
        }
        catch (err) {
            setError(errorMessage(err));
        }
        finally {
            setBusyKey(null);
        }
    });
    const reset = (key) => __awaiter(this, void 0, void 0, function* () {
        setBusyKey(key);
        setError(null);
        try {
            applyList(yield resetPrompt(key));
        }
        catch (err) {
            setError(errorMessage(err));
        }
        finally {
            setBusyKey(null);
        }
    });
    if (!prompts) {
        return error
            ? _jsx("p", { className: "pm-error", children: error })
            : _jsx("div", { className: "loading", children: "Loading prompts\u2026" });
    }
    return (_jsxs("div", { className: "prompts-manager", children: [_jsx("p", { className: "pm-intro", children: "These system prompts drive AI generation. Edit and save to override one; reset to return to the built-in default." }), error && _jsx("p", { className: "pm-error", children: error }), prompts.map(p => {
                var _a;
                const draft = (_a = drafts[p.key]) !== null && _a !== void 0 ? _a : '';
                const dirty = draft !== p.value;
                const busy = busyKey === p.key;
                return (_jsxs("div", { className: "pm-card", children: [_jsxs("div", { className: "pm-head", children: [_jsxs("div", { className: "pm-titles", children: [_jsx("span", { className: "pm-label", children: p.label }), _jsx("span", { className: "pm-desc", children: p.description })] }), _jsx("span", { className: `pm-badge ${p.isDefault ? 'default' : 'custom'}`, children: p.isDefault ? 'Default' : 'Custom' })] }), _jsx("textarea", { className: "pm-text", value: draft, disabled: busy, rows: 10, spellCheck: false, onChange: (e) => setDrafts(d => (Object.assign(Object.assign({}, d), { [p.key]: e.target.value }))) }), _jsxs("div", { className: "pm-actions", children: [_jsxs("button", { className: "pm-reset", disabled: busy || p.isDefault, onClick: () => reset(p.key), children: [_jsx(FaUndo, {}), " Reset to default"] }), _jsx("button", { className: "pm-save", disabled: busy || !dirty || !draft.trim(), onClick: () => save(p.key), children: busy ? _jsxs(_Fragment, { children: [_jsx(FaSpinner, { className: "pm-spin" }), " Saving\u2026"] }) : 'Save' })] })] }, p.key));
            })] }));
}
export default PromptsManager;
